import { use } from 'react';
import { RadioGroupContext } from './RadioGroupContext.ts';

/**
 * {@link useRadioGroup} is used by radio buttons to get values like name from their parent
 * radio group component.
 */
export function useRadioGroup() {
  const context = use(RadioGroupContext);
  if (context === undefined) {
    throw new Error('useRadioGroup must be used within a child of a RadioGroup.');
  }
  return context;
}
